import FederationArchitecture from "../../../../shared/diagrams/federation-architecture.mdx";
import { ExpansionPanel } from 'gatsby-theme-apollo-docs/src/components/expansion-panel';
import * as React from 'react';
export default {
  FederationArchitecture,
  ExpansionPanel,
  React
};